<div class="relative w-full h-full bg-slate-100">
    <app-left-nav class="fixed top-3 left-3 z-50"></app-left-nav>
    <div class="w-full h-full">
        <!-- Nav 7b final review (I6): pb-12 lets every dashboard screen scroll clear of the studio bar's strip. -->
        <div class="overflow-y-auto overflow-x-hidden bg-white  h-full  shadow-sm pb-12">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
